export default __webpack_public_path__ + "static/media/presentation.942d4e5d.svg";